import { render, staticRenderFns } from "./loadingChartErr.vue?vue&type=template&id=bc546446&scoped=true"
import script from "./loadingChartErr.vue?vue&type=script&lang=js"
export * from "./loadingChartErr.vue?vue&type=script&lang=js"
import style0 from "./loadingChartErr.vue?vue&type=style&index=0&id=bc546446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc546446",
  null
  
)

export default component.exports